import type { QuestionSnapshot } from "@/lib/api";

// Static practice content for MVP 2.0 #7. Four disposable questions the
// candidate sees on /t/<token>/practice BEFORE the timed test starts. Shape
// matches QuestionSnapshot (lib/api.ts:20 → openapi.schemas.QuestionSnapshot)
// so the existing MCQ / MCQMulti / CodeQuestion subcomponents render them
// identically to real test questions — that visual continuity is the whole
// point of practice (familiarisation, not separate UI).
//
// shuffle_answers is false everywhere — deterministic order is friendlier when
// the candidate is learning the UI. hidden_tests stays empty — practice has
// no scoring, so there's nothing to grade against.
// partial_credit (FEAT-27) is false for the same reason: the type requires
// the field, and nothing here is ever scored.
//
// Content is generic Python (NOT FinOps-themed). Practice teaches the UI, not
// the domain; a strong Python candidate new to FinOps shouldn't fail practice
// on the warm-up. If a recruiter ever asks for customisable practice (v2),
// this file gets replaced by a backend `practice_question` table.

export const PRACTICE_QUESTIONS: readonly QuestionSnapshot[] = [
  {
    type: "mcq",
    difficulty: "junior",
    prompt_md: "What does `len([1, 2, 3])` return?",
    correct_answer: "3",
    other_answers: ["4", "0", "TypeError"],
    shuffle_answers: false,
    partial_credit: false,
  },
  {
    type: "mcq_multi",
    difficulty: "junior",
    prompt_md:
      "Which of the following are built-in Python data types?\n\nSelect **all** that apply.",
    correct_answers: ["dict", "tuple"],
    other_answers: ["Map", "Array"],
    shuffle_answers: false,
    partial_credit: false,
  },
  {
    type: "code",
    difficulty: "junior",
    prompt_md:
      "Write a function `add(a, b)` that returns the sum of two integers.\n\nThis question won't be graded — it's here so you can try the editor and the **Run tests** button.",
    starter_code: "def add(a, b):\n    # Your code here\n    pass\n",
    example_tests: [
      { name: "two positives", input: "(2, 3)", expected_output: "5" },
      { name: "with a negative", input: "(-4, 1)", expected_output: "-3" },
    ],
    hidden_tests: [],
    shuffle_answers: false,
    partial_credit: false,
  },
  {
    type: "code",
    difficulty: "junior",
    prompt_md:
      "Write a function `count_vowels(s)` that returns the number of vowels (`a`, `e`, `i`, `o`, `u`) in the input string.\n\nAssume the input is already lowercase.",
    starter_code: "def count_vowels(s):\n    # Your code here\n    pass\n",
    example_tests: [
      { name: "simple", input: '"hello"', expected_output: "2" },
      { name: "empty string", input: '""', expected_output: "0" },
      { name: "no vowels", input: '"rhythm"', expected_output: "0" },
    ],
    hidden_tests: [],
    shuffle_answers: false,
    partial_credit: false,
  },
];
